import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { DialogHostComponent } from './components/dialog/dialog-host.component';
import { CookieConsentBannerComponent } from './components/cookie-consent-banner/cookie-consent-banner.component';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { FocusScrollService } from './services/focus-scroll.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, DialogHostComponent, CookieConsentBannerComponent],
  template: `
    <div class="min-h-screen bg-gray-50">
      <router-outlet />
      <app-toast-container />
      <app-dialog-host />
      <app-cookie-consent-banner />
    </div>
  `,
})
export class AppComponent {
  title = 'Askvo';

  // Needs Router + reactive consent, unlike the fire-and-forget Plausible/
  // Sentry init in main.ts — see google-analytics.service.ts.
  private readonly ga = inject(GoogleAnalyticsService);

  // Injected purely to instantiate it: it works off document-level focus
  // events, so nothing else ever references it. Here rather than in the
  // dashboard layout because login, register, support and onboarding all
  // need it and share no layout.
  private readonly focusScroll = inject(FocusScrollService);

  constructor() {
    this.ga.init();
  }
}
